var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[(_vm.imageSlider.length)?_c('VueSlickCarousel',_vm._b({ref:"carousel"},'VueSlickCarousel',_vm.settings,false),_vm._l((_vm.imageSlider),function(image,index){return _c('div',{key:index},[_c('img',{staticClass:"slider-image",attrs:{"src":image.file_url}})])}),0):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }